import moment from 'moment';

import { CAR_RENTAL_SEARCH_QUERY_PARAM_KEYS } from '@domain/carRental/searchBar/list/constants';
import {
  CAR_RENTAL_SEARCH_DATE_FORMAT,
  formatMomentDate,
} from '@utils/dateUtil';

export const CAR_RENTAL_FILTER_QUERY_PARAM_KEYS = {
  FUEL_TYPES: 'fueltypes',
  TRANSMISSION_TYPES: 'transmissiontypes',
  VEHICLE_CLASSES: 'vehicleclasses',
  PROVIDERS: 'providers',
  DOOR_COUNTS: 'doorcounts',
  SEAT_COUNTS: 'seatcounts',
  LUGGAGE_COUNTS: 'luggagecounts',
  PRICE_RANGE: 'pricerange',
  PRICE_MIN: 'priceMin',
  PRICE_MAX: 'priceMax',
  SORT: 'sort',
  PAGE: 'page',
  LIMIT: 'limit',
};

export const CAR_RENTAL_FILTER_QUERY_PARAM_KEYS_ARRAY = Object.values(
  CAR_RENTAL_FILTER_QUERY_PARAM_KEYS
);

/**
 * NOTE: If the constants of the default date and time values will be refactored, we also need to check whether the values appear in the searchbar on the listing page when the car rental links in the header are opened.
 */
export const DEFAULT_CAR_RENTAL_PICK_UP_DATE = moment().add(7, 'days');
export const DEFAULT_CAR_RENTAL_DROP_OFF_DATE = moment().add(9, 'days');

export const DEFAULT_CAR_RENTAL_PICK_UP_TIME = '09:00';
export const DEFAULT_CAR_RENTAL_DROP_OFF_TIME = '09:00';

export const DEFAULT_CAR_RENTAL_SEARCH_QUERY_PARAM_VALUES = {
  [CAR_RENTAL_SEARCH_QUERY_PARAM_KEYS.PICK_UP_DATE]: formatMomentDate(
    DEFAULT_CAR_RENTAL_PICK_UP_DATE,
    CAR_RENTAL_SEARCH_DATE_FORMAT
  ),
  [CAR_RENTAL_SEARCH_QUERY_PARAM_KEYS.PICK_UP_TIME]:
    DEFAULT_CAR_RENTAL_PICK_UP_TIME,
  [CAR_RENTAL_SEARCH_QUERY_PARAM_KEYS.DROP_OFF_DATE]: formatMomentDate(
    DEFAULT_CAR_RENTAL_DROP_OFF_DATE,
    CAR_RENTAL_SEARCH_DATE_FORMAT
  ),
  [CAR_RENTAL_SEARCH_QUERY_PARAM_KEYS.DROP_OFF_TIME]:
    DEFAULT_CAR_RENTAL_DROP_OFF_TIME,
};
